// Holds the list of individual My Content object keys ("kind:id") currently
// HIDDEN from the map. Empty array = everything visible (the default). See the
// per-item "Hide on Map" kebab option in src/component/main-ui/left-toolbar/
// my-content and the render-* consumers. Session-only (see store.js blacklist).

import {
  TOGGLE_CONTENT_ID_VISIBILITY,
  CONTENT_IDS_VISIBILITY_RESET,
} from '../action/hidden-content-ids-actions'

const initialState = []

export default (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_CONTENT_ID_VISIBILITY: {
      const key = action.payload
      return state.includes(key)
        ? state.filter(k => k !== key)
        : [...state, key]
    }
    case CONTENT_IDS_VISIBILITY_RESET:
    case 'LOGOUT':
      return initialState
    default:
      return state
  }
}
